// Mounts for every logged-in user, regardless of role. Pulls the
// shared qb_sync_cache from /api/data/qb-cache and hydrates this
// browser's localStorage so non-admins (Robert, etc.) see the same
// QB data Adam pulled, without needing access to the sync button.
//
// Previously this lived inside QBSyncButton, which is gated to
// Adam-only render in App.jsx. Non-admins never mounted that
// component → hydrate never fired → their ACTUALS_CUTOFF_2026
// stayed at the default (3) and the dashboard showed March
// numbers indefinitely.
//
// This is a no-UI component. The matching write path (after a fresh
// sync) still lives in QBSyncButton — only the read/hydrate is
// extracted here so it's universally available.

import { useEffect } from 'react';
import { apiFetch } from '../../utils/apiFetch';

export default function QBCacheHydrator() {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await apiFetch('/api/data/qb-cache');
        const data = await res.json();
        if (cancelled || !res.ok || !data.cache) return;
        const c = data.cache;
        const prevThrough = parseInt(localStorage.getItem('bcc_qb_through_month')) || 0;

        if (c.raw_pl) localStorage.setItem('bcc_qb_raw_pl', JSON.stringify(c.raw_pl));
        if (c.raw_bs) localStorage.setItem('bcc_qb_raw_bs', JSON.stringify(c.raw_bs));
        if (c.raw_cf) localStorage.setItem('bcc_qb_raw_cf', JSON.stringify(c.raw_cf));
        if (c.mapped_pl) localStorage.setItem('bcc_qb_mapped_pl', JSON.stringify(c.mapped_pl));
        if (c.mapped_cf) localStorage.setItem('bcc_qb_mapped_cf', JSON.stringify(c.mapped_cf));
        if (c.mapped_bs) localStorage.setItem('bcc_qb_mapped_bs', JSON.stringify(c.mapped_bs));
        if (c.through_month != null) localStorage.setItem('bcc_qb_through_month', String(c.through_month));
        if (c.last_sync_at) localStorage.setItem('bcc_qb_last_sync', c.last_sync_at);

        // ACTUALS_CUTOFF_2026 is a module-level constant in
        // FinancialDataContext, computed from localStorage at JS bundle
        // load. The async hydrate above runs AFTER that, so the constant
        // has already frozen at the stale value. If the server cache has
        // moved through_month forward, force one reload so the constant
        // picks up the fresh value. sessionStorage flag prevents loops.
        const newThrough = parseInt(c.through_month) || 0;
        if (newThrough > prevThrough && !sessionStorage.getItem('bcc_qb_hydrate_reloaded')) {
          sessionStorage.setItem('bcc_qb_hydrate_reloaded', '1');
          window.location.reload();
        }
      } catch (e) {
        console.warn('[QBCacheHydrator] failed to hydrate cache from API:', e);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return null;
}
